module.exports = __webpack_public_path__ + "static/media/598.b977fb63.png";